import {
  Dimension__toString_impl_o4q1adx82fzjdnbyok as Dimension__toString_impl_o4q1ad,
  Dimension__hashCode_impl_p583vw27ml4nzz2xkra as Dimension__hashCode_impl_p583vw,
} from './data.mjs';
import { getNumberHashCode2l4nbdcihl25f as getNumberHashCode } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/bitUtils.mjs';
import { equals2au1ep9vhcato as equals } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var WindowStatisticsClass;
function WindowStatistics() {
  if (WindowStatisticsClass === VOID) {
    class $ {
      constructor(width, height, density) {
        this.ebi_1 = width;
        this.fbi_1 = height;
        this.gbi_1 = density;
      }
      toString() {
        return 'WindowStatistics(width=' + Dimension__toString_impl_o4q1ad(this.ebi_1) + ', height=' + Dimension__toString_impl_o4q1ad(this.fbi_1) + ', density=' + this.gbi_1 + ')';
      }
      hashCode() {
        var result = Dimension__hashCode_impl_p583vw(this.ebi_1);
        result = imul(result, 31) + Dimension__hashCode_impl_p583vw(this.fbi_1) | 0;
        result = imul(result, 31) + getNumberHashCode(this.gbi_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof WindowStatistics()))
          return false;
        if (!equals(this.ebi_1, other.ebi_1))
          return false;
        if (!equals(this.fbi_1, other.fbi_1))
          return false;
        if (!equals(this.gbi_1, other.gbi_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'WindowStatistics');
    WindowStatisticsClass = $;
  }
  return WindowStatisticsClass;
}
//region block: exports
export {
  WindowStatistics as WindowStatisticscvqq0mhzo3xj,
};
//endregion

//# sourceMappingURL=WindowStatistics.mjs.map
